import CreatableSelect from 'react-select/creatable';
import useSWR from 'swr';

import { getMenuCategoryOptions, useStock } from '@services/stock';

import styles from '../DeliveryChannelsCard.module.scss';
import { useParams } from 'react-router-dom';
import { InputGroup } from '@nearst/ui';
import { useCheckPermission } from '@services/auth/hooks';

const MenuCategoriesContainer = ({ onChange }) => {
	const { barcode, shopId } = useParams();
	const { data: stockItem } = useStock(barcode, shopId, { suspense: true });
	const [aisle, shelf] = stockItem?.deliveryCategories || [];
	const { data: { aisleOptions, shelfOptions } = {}, isLoading } = useSWR(['autocomplete-delivery-categories', shopId, aisle], () =>
		getMenuCategoryOptions(shopId, aisle)
	);
	const authorized = useCheckPermission('org:inventory:edit');

	const handleAisleChange = (selected) => {
		const aisle = selected?.value;
		if (aisle) {
			onChange([aisle]);
		} else {
			onChange([]);
		}
	};

	const handleShelfChange = (selected) => {
		const shelf = selected?.value;
		if (shelf) {
			onChange([aisle, shelf]);
		} else {
			onChange([aisle]);
		}
	};

	return (
		<div className={styles.menuCategoriesContainer}>
			<InputGroup label="Aisle">
				<CreatableSelect
					className={styles.select}
					isClearable={false}
					placeholder={'Select aisle...'}
					formatCreateLabel={(inputValue) => `Use: "${inputValue}"`}
					value={aisle ? { value: aisle, label: aisle } : null}
					onChange={handleAisleChange}
					isDisabled={!authorized}
					options={aisleOptions}
					isLoading={isLoading}
					components={{ IndicatorSeparator: () => null }}
				/>
			</InputGroup>
			<InputGroup label="Shelf">
				<CreatableSelect
					className={styles.select}
					isClearable={false}
					placeholder={'Select shelf...'}
					formatCreateLabel={(inputValue) => `Use: "${inputValue}"`}
					key={aisle} // force remount when aisle changes
					value={shelf ? { value: shelf, label: shelf } : null}
					onChange={handleShelfChange}
					isDisabled={!authorized || !aisle}
					options={shelfOptions}
					isLoading={isLoading}
					components={{ IndicatorSeparator: () => null }}
				/>
			</InputGroup>
		</div>
	);
};

export default MenuCategoriesContainer;
